import axios from "axios";

export const getDescriptionForProduct = (productId: string) => {
    return axios.get<string>("products/description/" + productId);
};

export const getIngredientsForProduct = (productId: string) => {
    return axios.get<string>("products/ingredients/" + productId);
};